import { Button, Dialog, GeneralForm, GeneralFormItem, GeneralFormRowOfItems, LargeAddIcon, RenderIf } from '@lib/ui-components';
import { DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import { Breakpoint } from '@mui/system';
import { useTranslation } from 'react-i18next';
import styles from '../../form/general-form/styles.module.css';

export interface ButtonFormDialogProps {
  dialogTitle?: string;
  fields?: (GeneralFormItem | GeneralFormRowOfItems)[];
  validationSchema?: any;
  hiddenValues?: any;
  dialogIcon?: JSX.Element;
  maxWidth?: Breakpoint | false;
  bottomMessage?: string;
  openDialog: boolean;
  setDialog: React.Dispatch<React.SetStateAction<boolean>>;
  handleSaveDialog: (formData: any) => void;
  warningMessage?: string;
  dialogText?: string;
}

export const ButtonFormDialog = (props: ButtonFormDialogProps) => {
  const { t } = useTranslation();

  async function handleCloseDialog() {
    props.setDialog(false);
  }

  function handleTextDialogSave() {
    props.handleSaveDialog({});
  }

  const isTextDialog = !!props.dialogText;

  return (
    <Dialog open={props.openDialog} onClose={() => handleCloseDialog()} maxWidth={props.maxWidth === undefined ? 'md' : props.maxWidth} fullWidth={true}>
      <div style={{ margin: 'auto', marginTop: '2rem' }}>{props.dialogIcon ? props.dialogIcon : <LargeAddIcon />}</div>
      <DialogTitle sx={{ margin: 'auto' }}>
        {props.dialogTitle}
        <IconButton
          aria-label='close'
          onClick={handleCloseDialog}
          data-test-id={'dialog-close-btn'}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <RenderIf true={props.warningMessage !== undefined && props.warningMessage !== ''}>
          <DialogTitle
            sx={{
              fontSize: '1rem',
              marginLeft: '-1rem',
              textAlign: 'left',
              color: 'error.main',
            }}
          >
            {props.warningMessage}
          </DialogTitle>
        </RenderIf>

        <RenderIf true={isTextDialog}>
          <Typography sx={{ paddingLeft: '0.5rem' }}>{props.dialogText}</Typography>
          <div className={styles['formButtonsGridContainer']}>
            <div className={styles['formButtonsCenterItems']}>
              <Button label={t('Common.cancel')} color='primary' variant='text' onClick={async () => handleCloseDialog()} />
              <Button label={t('save')} color='secondary' variant='contained' onClick={async () => handleTextDialogSave()} />
            </div>
          </div>
        </RenderIf>

        <RenderIf true={!isTextDialog}>
          <GeneralForm
            fields={props.fields || []}
            validationSchema={props.validationSchema}
            onSaved={async (data) => props.handleSaveDialog(data)}
            onCanceled={async () => handleCloseDialog()}
            hideCancelButton={false}
            hiddenValues={props.hiddenValues}
            variant='standard'
          />
        </RenderIf>

        {props.bottomMessage && (
          <DialogTitle
            sx={{
              margin: 'auto',
              fontSize: '1rem',
              maxWidth: '30rem',
              textAlign: 'center',
            }}
          >
            {props.bottomMessage}
          </DialogTitle>
        )}
      </DialogContent>
    </Dialog>
  );
};
